import {
    ISection2DocumentDetails,
    ISection2DocumentDetailsForm
} from '@models/onboarding-review/section2-document-details';
import { Section2DocumentDetailsStore } from '@stores/onboarding-review/section2-document-details-store';
import {
    each,
    filter,
    map,
    includes as _includes
} from 'lodash';
import {
    action,
    computed,
    observable,
    ObservableMap
} from 'mobx';
import { IConfigurationValuesService } from '@services/ConfigurationValuesService';
import { Section2DocumentTypesValidationStore, ISection2DocumentTypesValidation } from './section2-document-types-validation-store';
import {
    I9DocumentGroupsEnum
  } from '@swipejobs/i9-document-validations-react';
  import {I9DocumentInfoDto} from '@swipejobs/i9-document-validations-react';

export interface ISection2DocumentsStore extends Readonly<ISection2DocumentDetailsForm> {
    readonly allDocuments: ISection2DocumentDetails[];
    readonly documentTypesValidationsAll: ISection2DocumentTypesValidation[];
    readonly applicantStatus: string | null;
    readonly loadingApplicantStatus: boolean;
    setDocuments(documents: ISection2DocumentDetails[]): void;
    setDocumentTypesValidation(documentTypesValidation: I9DocumentInfoDto[]): void;
    setWorkerStatus(workerStatus: string | null): void;
}

export class Section2DocumentsStore implements ISection2DocumentsStore {
    @observable
    documents: ObservableMap<string, Section2DocumentDetailsStore> = new ObservableMap<string, Section2DocumentDetailsStore>();

    @observable
    documentTypesValidation: ObservableMap<string, Section2DocumentTypesValidationStore> = new ObservableMap<string, Section2DocumentTypesValidationStore>();
    
    @observable
    private workerStatus: string | null = '';

    @observable
    loadingApplicantStatus = true;
    
    constructor(
        private configurationValuesService: IConfigurationValuesService
    ) {
    }

    @computed
    get listA(): ISection2DocumentDetails[] {
        const listADocumentTypes = map(filter(Array.from(this.documentTypesValidation.values()),
        (document) => {
         return (_includes(document.documentGroups,I9DocumentGroupsEnum.I9_LIST_A) && document.i9Section2Excluded === false);
         
        }),'documentType');
        return filter(
            Array.from(this.documents.values()),
            (document: Section2DocumentDetailsStore) =>
                listADocumentTypes.includes(document.documentType) &&
                document.documentType ===
                    document.documentType.replace('_BACK', '')
        );
    }

    @computed
    get listB(): ISection2DocumentDetails[] {
        const listBDocumentTypes = map(filter(Array.from(this.documentTypesValidation.values()),
        (document) => {
         return (_includes(document.documentGroups,I9DocumentGroupsEnum.I9_LIST_B) && document.i9Section2Excluded === false);
         
        }),'documentType');
        return filter(
            Array.from(this.documents.values()),
            (document: Section2DocumentDetailsStore) => listBDocumentTypes.includes(document.documentType)
        );
    }

    @computed
    get listC(): ISection2DocumentDetails[] {
        const listCDocumentTypes = map(filter(Array.from(this.documentTypesValidation.values()),
        
        (document) => {
         return (_includes(document.documentGroups,I9DocumentGroupsEnum.I9_LIST_C) && document.i9Section2Excluded === false);
         
        }),'documentType');
     
        return filter(
            Array.from(this.documents.values()),
            (document: Section2DocumentDetailsStore) => listCDocumentTypes.includes(document.documentType)
        );
    }

    @computed
    get allDocuments(): ISection2DocumentDetails[] {
        return Array.from(this.documents.values());
    }

    @computed
    get documentTypesValidationsAll() {
        return Array.from(this.documentTypesValidation.values());
    }

    @computed
    get applicantStatus(): string | null {
        return this.workerStatus;
    }

    @action.bound
    setDocuments(documents: ISection2DocumentDetails[]): void {
        this.documents.clear();
        each(documents, document => {
            const store = new Section2DocumentDetailsStore(document);
            this.documents.set(document.documentType, store);
        });
    }

    @action.bound
    setDocumentTypesValidation( documentTypes: I9DocumentInfoDto[]): void {
        each(documentTypes, document => {
            const store = new Section2DocumentTypesValidationStore(document);
            this.documentTypesValidation.set(document.documentType, store);
        })
    }

    @action.bound
    setWorkerStatus( value: string | null ): void {
        this.workerStatus = value;
        this.loadingApplicantStatus = false;
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-documents-store.ts